import { defineStore } from 'pinia'

export const useStateStore = defineStore('state', {
    state: () => ({
        errors: {},
        form: {},
        formFields: [],
        formSubmitted: false,
    })
});